import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { Decoration, DecorationSet } from '@tiptap/pm/view';
import type { Node as PMNode } from '@tiptap/pm/model';

export const WORD_CODE_ONLY_CLASS = 'word-code-only';

/** Absatz, dessen Inhalt komplett Inline-Code ist (Word: Consolas-8-pt-Zeile, 9.37 pt hoch). */
export function isCodeOnlyParagraph(node: PMNode): boolean {
  if (node.type.name !== 'paragraph' || node.childCount === 0) return false;
  let codeOnly = true;
  node.forEach((child) => {
    if (!child.isText || !child.marks.some((m) => m.type.name === 'code')) codeOnly = false;
  });
  return codeOnly;
}

function decorate(doc: PMNode): DecorationSet {
  const decos: Decoration[] = [];
  doc.descendants((node, pos) => {
    if (isCodeOnlyParagraph(node)) {
      decos.push(Decoration.node(pos, pos + node.nodeSize, { class: WORD_CODE_ONLY_CLASS }));
    }
    return node.type.name !== 'paragraph';
  });
  return DecorationSet.create(doc, decos);
}

/**
 * Markiert reine Code-Absätze, damit der Fokusmodus sie mit Words Zeilenhöhe
 * setzt: die Absatzmarke (12 pt) zählt in Word nicht, wenn Läufe vorhanden sind.
 */
export const WordCodeOnlyParagraphs = Extension.create({
  name: 'wordCodeOnlyParagraphs',
  addProseMirrorPlugins() {
    const key = new PluginKey('wordCodeOnlyParagraphs');
    return [
      new Plugin({
        key,
        state: {
          init: (_, state) => decorate(state.doc),
          apply: (tr, old) => (tr.docChanged ? decorate(tr.doc) : old),
        },
        props: {
          decorations(state) {
            return key.getState(state);
          },
        },
      }),
    ];
  },
});
